// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1MQL5","boxTitle":"Qualiphy_boxTitle__3wvI4","box":"Qualiphy_box__23n_P","toggleWrap":"Qualiphy_toggleWrap__3t-X1"};